import React, { FunctionComponent, useContext, useEffect, useState } from 'react'
import i18n from 'live/services/i18n'
import { StyledLiveModal } from './ModalScheduling'
import { ReportContext } from '../../../../src/app'
import { MailSettingsInstance } from 'plugin-reports-maker/webapp/js/common/types/api/report'

export interface ScheduleData {
    reportUid: string
    settings: MailSettingsInstance
}

interface ModalSchedulingActionsProps<T> {
    title: string
    schedule: MailSettingsInstance
    Content: FunctionComponent<ModalSchedulingAction<T>>

    loadData: (sheduleData: ScheduleData) => Promise<T>
    submitData: (data: T, sheduleData: ScheduleData) => Promise<T>
    onHide: () => void
}

export interface ModalSchedulingAction<T> {
    data: T
    onHide: () => void
    setData: (data: T) => void
    error: string | undefined
    loaded: boolean
    schedule: ScheduleData
    report: any
}

export function ModalSchedulingActions<T>({
    title,
    Content,
    schedule,
    submitData,
    loadData,
    onHide
}: ModalSchedulingActionsProps<T>): JSX.Element {
    const [state, setState] = useState<{
        data: T | undefined
        loaded: boolean
        error: string | undefined        
    }>({
        data: undefined,
        loaded: false,
        error: undefined,
    })

    const { report, dispatch } = useContext(ReportContext)

    const resetState = () => {
        setState({
            data: undefined,
            error: undefined,
            loaded: false
        })
        onHide()
    }
    useEffect(() => {
        if (!state.loaded && report && loadData) {
            loadData({
                reportUid: report.uid,
                settings: schedule
            })
                .then(data =>
                    setState(() => ({
                        data,
                        loaded: true,
                        error: undefined
                    }))
                )
                .catch(error => {
                    setState(() => ({
                        data: undefined,
                        loaded: true,
                        error: String(error)
                    }))
                })
        }
    }, [title, loadData, report])

    return (
        <StyledLiveModal key={'modalscheduling'} show={true} onHide={onHide} animation={false} className="modal-sm">
            <StyledLiveModal.Header>
                <StyledLiveModal.Title>{i18n(`Schedule: ${schedule?.name}`)}</StyledLiveModal.Title>
            </StyledLiveModal.Header>
            <StyledLiveModal.Body>
                <Content
                    onHide={resetState}
                    data={state?.data}
                    setData={currentData => {
                        setState(e => ({ ...e, data: currentData }))
                    }}
                    error={state?.error}
                    loaded={state?.loaded}
                    report={report}
                    schedule={schedule}
                />
            </StyledLiveModal.Body>
            <StyledLiveModal.Footer>
                <StyledLiveModal.ModalActions
                    onSubmit={() => {
                        if (submitData) {
                            submitData(state?.data, {
                                reportUid: report.uid,
                                settings: schedule
                            }).finally(() => {
                                resetState()
                            })
                        }
                    }}                    
                    submitText={i18n('Save')}
                    submitBtnClassName="btn btn-primary"
                    cancelBtnClassName={null}
                    onCancel={() => {
                        resetState()
                    }}
                    cancelText={i18n('Cancel')}
                />
            </StyledLiveModal.Footer>
        </StyledLiveModal>
    )
}
